<template lang="pug">
  .container.grid-lg
    page-title(title="Assinatura com meu link" icon="fas fa-dollar-sign" subtitle="Detalhes da assinatura")
    .flex-centered.content-full-height(v-if="loading") #[.loading.loading-lg]
    div(v-else-if="!error && current")
      div Assinatura realizada em #[span.text-bold {{ current.subscription.createdAt | date('DD/MM/YYYY HH:mm') }}]
      .columns
        .column.col-10.col-md-12
          .columns
            .column.col-7.col-md-6.col-sm-12.my-2
              info-card(title="Assinante" icon="fas fa-user")
                .card-body(slot="card-body")
                  .columns.align-center
                    .column.col-auto
                      user-avatar.avatar-xl(:user="current.subscription.person")
                    .column.text-ellipsis
                      .text-ellipsis.text-bold {{ current.subscription.person.fullName }}
                      .text-ellipsis {{ current.subscription.person.email }}
            .column.col-5.col-md-6.col-sm-12.my-2
              info-card(title="Valores" icon="fas fa-money-bill-wave")
                .card-body(slot="card-body")
                  .columns
                    .column.text-ellipsis Valor da assinatura
                    .column.col-auto {{ current.subscription.plan.price | currency('R$ ') }}
                  .columns
                    .column.text-ellipsis Seu percentual
                    .column.col-auto {{ current.percentage | currency('', ' %') }}
                .card-footer(slot="card-footer")
                  .divider
                  .columns
                    .column.text-ellipsis Você recebe
                    .column.col-auto.text-bold.text-success {{ current.amount | currency('R$ ') }}
    .flex-centered.content-full-height(v-else-if="error") #[error-box(:error="error")]
</template>

<script>
import filiationSubscriptions from '@/services/api/filiationSubscriptions'

export default {
  data() {
    return { loading: true, error: null, current: null }
  },
  methods: {
    async fetchCurrent() {
      try {
        this.loading = true
        const { data } = await filiationSubscriptions.show(
          this.$route.params.id,
        )
        this.current = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
  },
  created() {
    this.fetchCurrent()
  },
}
</script>
